// extracted by mini-css-extract-plugin
export default {"passkeyListContainer":"widgets-contacts-and-settings-fields-ProfileAndSecurity-Passkeys-components-PasskeyList__passkeyListContainer--UX67J"};